import _ from 'lodash'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Icon, Label, Segment, Sidebar } from 'semantic-ui-react'
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext'
import UiSaveButtons from '../../../../global/components/buttons/UiSaveButtons'
import DataSidebar from '../../../../global/components/swipers/DataSidebar'
import { appFormTypes } from '../../../../global/enums/appFormTypes'
import { clickOriginTypes } from '../../../../global/enums/globalEnums'
import FullPageWrapper from '../../../../global/wrappers/FullPageWrapper'
import TransitionWrapper, { transitionWrapperTypes } from '../../../../global/wrappers/TransitionWrapper'
import Wrapper, { wrapperTypes } from '../../../../global/wrappers/Wrapper'
import { SportsDistrictContext } from '../../cnr/contexts/SportsDistrictContext'
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext'
import ParentKeysDd from '../dropdowns/ParentKeysDd'
import RssSearchDashboard from 'projectSpecific/sports/create/subs/RssSearchDashboard'
import WeeksTimeline from './WeeksTimeline'
import { TeamsDashboard } from './TeamsDashboard'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import CreateSponsors from 'projectSpecific/sports/create/CreateSponsors'
import CalendarTimeline from './CaldendarTimeline'

const AppDataTransferDirectWithProvider = React.lazy(() => import('../../../../global/pageItem/modification/dataModifications/AppDataTransferDirect'));
const CreateSports = React.lazy(() => import('../../create/CreateSports'));
const DistrictSports = React.lazy(() => import('../schools/DistrictSports'));
const DistrictSchools = React.lazy(() => import('../schools/DistrictSchools'));
const MatchDataUpdate = React.lazy(() => import('../matches/MatchDataUpdate'));
const MatchPlayoffUpdate = React.lazy(() => import('../matches/MatchPlayoffUpdate'));
const OrganizationDistricts = React.lazy(() => import('../organization/OrganizationDistricts'));
const SeasonalData = React.lazy(() => import('../../create/subs/SeasonalData'));
const SeasonGrids = React.lazy(() => import('../matches/SeasonGrids'));
const SeasonRankingsUpdate = React.lazy(() => import('../matches/SeasonRankingsUpdate'));
const SportSchools = React.lazy(() => import('../schools/SportSchools'));
const SportsDataIssues = React.lazy(() => import('../../create/subs/SportsDataIssues'));
const SportsDataSidebar = React.lazy(() => import('../../create/SportsDataSidebar'));
const UiDashboardForm = React.lazy(() => import('../../../../global/pageItem/modification/dataModifications/UiDashboardForm'));
const ValidateSports = React.lazy(() => import('../../create/subs/ValidateSports'));

const _sdm_sports = {
  results: {
    seasonResults: 'seasonResults',
  },
  seasons: {
    createSeason: 'createSeason',
    editCurrentSeason: 'editCurrentSeason',
    modifySeasonMatches: 'modifySeasonMatches',
    modifySchedules: 'modifySchedules',
    sectionGrids: 'sectionGrids',
  },
  playoffs: {
    createPlayoff: 'createPlayoff',
    playoffPendingMatches: 'playoffPendingMatches',
  },
  rankings: {
    seasonRankings: 'seasonRankings',
  },
  teams: {
    teamAccess: 'teamAccess',
    teamRosters: 'teamRosters',
    teamLinks: 'teamLinks',
  },
  tournaments: {
    createTournament: 'createTournament',
    createTournamentPlayoff: 'createTournamentPlayoff',
    tournamentResults: 'tournamentResults',
  },
  access: {
    sportsAccess: 'sportsAccess',
  },
  sponsors: {
    sponsors: 'sponsors',
  },
  news: {
    news: 'news',
  },
  data: {
    sportsData: 'sportsData',
  },
  other: {
    appUserCount: 'appUserCount',
    appUserDailyCount: 'appUserDailyCount',
    sportsSettings: 'sportsSettings',
  }
}

const _sdm_district = {
  access: {
    schoolsAccess: 'schoolsAccess',
    sportsAccess: 'sportsAccess',
  },
  contacts: {
    contactsDistrict: 'contactsDistrict',
    contactsSchools: 'contactsSchools',
  },
  data: {
    districtSchools: 'districtSchools',
    districtSports: 'districtSports',
  },
  google: {
    glsAccess: 'glsAccess',
    glsDistrict: 'glsDistrict',
    glsScores: 'glsScores',
  },
  media: {
    rssFeeders: 'rssFeeders',
  },
  other: {
    appUserCount: 'appUserCount',
    appUserDailyCount: 'appUserDailyCount',
    dataIssues: 'dataIssues',
    sportsDashboard: 'sportsDashboard',
    sportsData: 'sportsData',
    transferData: 'transferData',
    updateDistrictSeasonScores: 'updateDistrictSeasonScores',
  }
}

const _sdm_organization = {
  organizations: {
    all: 'all',
  },
  organization: {
    districts: 'districts',
    schools: 'schools',
    sports: 'sports',
  }
}

export const _sdm = {
  sports: {
    menu: 'menu',
    ..._sdm_sports.access,
    ..._sdm_sports.media,
    ..._sdm_sports.other,
    ..._sdm_sports.playoffs,
    ..._sdm_sports.rankings,
    ..._sdm_sports.results,
    ..._sdm_sports.seasons,
    ..._sdm_sports.sponsors,
    ..._sdm_sports.teams,
    ..._sdm_sports.tournaments,
  },
  schools: {
    menu: 'menu',
    sportsDashboard: 'sportsDashboard',
  },
  district: {
    menu: 'menu',
    ..._sdm_district.access,
    ..._sdm_district.contacts,
    ..._sdm_district.data,
    ..._sdm_district.google,
    ..._sdm_district.media,
    ..._sdm_district.other,
  },
  organization: {
    menu: 'menu',
    ..._sdm_organization.organizations,
    ..._sdm_organization.organization,
  },
  any: {
    ..._sdm_district.access,
    ..._sdm_district.contacts,
    ..._sdm_district.data,
    ..._sdm_district.google,
    ..._sdm_district.other,
    ..._sdm_organization.organizations,
    ..._sdm_organization.organization,
    ..._sdm_sports.access,
    ..._sdm_sports.other,
    ..._sdm_sports.playoffs,
    ..._sdm_sports.rankings,
    ..._sdm_sports.results,
    ..._sdm_sports.seasons,
    ..._sdm_sports.sponsors,
    ..._sdm_sports.teams,
    ..._sdm_sports.tournament,
  }
}

const _caption = 'Sports Dashboard'

const SportsDashboard = (props) => {

  const { handleCancel, _selectedDataMode } = props ?? {}

  // parentContext
  const parentContext = useContext(ParentContext)
  const { states, handlers } = parentContext ?? {}
  const { paps_state } = states ?? {}
  const { analytics_handlers } = handlers ?? {}
  const { pathModes, pathViews } = paps_state ?? {}
  const { handleLogging_event } = analytics_handlers ?? {}

  // sportsDistrictContext
  const sportsDistrictContext = useContext(SportsDistrictContext)
  const { sportsDistrict_state } = sportsDistrictContext ?? {}
  const { dailyCounts, dailyCountsU, currentUserCounts, currentUserCount, lastItemCount } = sportsDistrict_state ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, parentDataKeys, latestSeason_full } = sportsSeason_state ?? {}
  const { latestSeason, sportsKey, _sportsYearAbr, _sportsAbr, _sportsModeKey, _sportsModeSport } = currentSeason_info ?? {}
  const { matches_seasonal: pks_matches_seasonal } = parentDataKeys ? parentDataKeys : {}

  const [captions, setCaptions] = useState({ topper: _caption, topper2: 'Sports Data' })
  const [activeMenuItems, setActiveMenuItems] = useState({})
  const [activeMenuGroups, setActiveMenuGroups] = useState({})
  const [mode, setMode] = useState()
  const [sportsDataMode, setSportsDataMode] = useState()

  // useEffect(() => {
  //   handleLogging_event && handleLogging_event("screen_view", {
  //     screen_name: "SportsDashboard", // Replace with your screen name or page identifier
  //   });
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {

    let _menuItems = {}
    let modes = {}
    let firstMode = _sdm.sports.editSeason;
    let modeGroup = {}

    if (pathModes.sport) {
      modes = _sdm.sports
      modeGroup = _sdm_sports
      firstMode = _sdm.sports.menu
    } else if (pathModes.school) {
      modes = _sdm.schools
      modeGroup = _sdm.schools
      firstMode = _sdm.schools.menu
    } else if (pathModes.district) {
      modes = _sdm.district
      modeGroup = _sdm_district
      firstMode = _sdm.district.menu
    } else if (pathModes.organization) {
      modes = _sdm.organization
      modeGroup = _sdm_organization
      firstMode = _sdm.organization.menu
    }

    Object.keys(modes).forEach(k => {
      _menuItems[k] = k
    })

    setSportsDataMode(_selectedDataMode || firstMode)
    setCaptions({ topper: _caption })
    setActiveMenuItems(_menuItems)
    setActiveMenuGroups(modeGroup)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sportsKey, _sportsModeKey, currentUserCount]);

  const handleMode = (adm) => setMode(adm)

  const handleDataMode = (adm) => {
    const _adm = adm ? adm : _sdm.district.glsScores
    setSportsDataMode(_adm)
    setCaptions({ topper: _caption })
    setMode()
  }

  const handleClose = () => {
    if (pathModes.sport) {
      setSportsDataMode(_sdm.sports.menu)
    } else if (pathModes.district) {
      setSportsDataMode(_sdm.district.sportsDashboard)
    } else if (pathModes.organization) {
      setSportsDataMode(_sdm.organization.menu)
    }
  }

  const fnAltContent = (item) => {
    switch (item) {
      case 'appUserCount':
        return <div style={{ display: 'flex', columnGap: '.5em' }}>
          <Label size='mini' color='blue'>{`${lastItemCount}/${currentUserCount}`}</Label>
        </div>
      case 'appUserDailyCount':
        return <div style={{ display: 'flex', columnGap: '.5em' }}>
          <Label size='mini' color='green'>{`${dailyCounts?.todaysCount?.count}`}</Label>
          <Label size='mini' color='green'>{`${dailyCountsU?.todaysCount?.count}`}</Label>
        </div>
    }
  }

  const squares = () => {
    if (activeMenuGroups) {
      return _.map(activeMenuGroups, (amg, amgKey) => (
        <ItemMenuSquares
          menuItems={amg}
          imsType={_imsTypes.inline}
          caption={_.startCase(amgKey)}
          icon={'list'}
          onClick={handleDataMode}
          fn_altContent={fnAltContent}
        />
      ))
    }
  }

  /**
   * 
   * @returns a menu of with a list of the activeMenuItems
   */
  const menu_left = () => {
    activeMenuItems['count'] = currentUserCount
    return <TransitionWrapper transitionWrapperType={transitionWrapperTypes.itemSimple}>
      {squares()}
    </TransitionWrapper>

  }

  const sidebar_left = (visible) => <DataSidebar direction={'left'} visible={visible} content={visible && menu_left()} onHide={handleMode} />

  const modeButton = () => {
    const btns = [
      { caption: _.startCase(sportsDataMode), oc: handleMode, icon: 'content' },
    ]
    return <UiSaveButtons
      others={btns}
      color={'black'}
    />
  }

  const label_icon = (icon, text) => <Label color='blue'>
    <Icon name={icon} /> {text}
  </Label>

  const statusDiv = () => <div>
    {label_icon('trophy', _.startCase(_sportsModeKey))}
    {label_icon('key', sportsKey)}
    {label_icon('sitemap ', pks_matches_seasonal)}
    {label_icon('users', currentUserCount)}
    {label_icon('calendar outline', latestSeason_full)}
  </div>

  const content = useMemo(() => {

    switch (sportsDataMode) {

      case _sdm.district.menu:
      case _sdm.schools.menu:
      case _sdm.sports.menu:
      case _sdm.organization.menu:
        return <Segment basic className='app-dark-mode hwcc'>Please select a sports menu item</Segment>

      case _sdm.sports.sportsSeasons:
        return <SeasonalData fromDashboard={true} sportsKey={sportsKey} />

      case _sdm.district.schoolsAccess:
      // case _sdm.district.sportsAccess:
      case _sdm.district.contactsDistrict:
      case _sdm.district.contactsSchools:
      case _sdm.district.glsScores:
      case _sdm.any.sportsData:
      case _sdm.district.updateDistrictSeasonScores:
      case _sdm.sports.news:
      case _sdm.sports.tournamentResults:
        return <SportsDataSidebar sportsDataMode={sportsDataMode} forSportsManagement={true} />

      case _sdm.sports.teamsDashboard:
      case _sdm.sports.teamAccess:
      case _sdm.sports.googleSheetKeys:
      case _sdm.sports.teamLinks:
      case _sdm.sports.teamRosters:
      case _sdm.district.sportsAccess:
        return <TeamsDashboard sportsDataMode={sportsDataMode} />

      case _sdm.district.rssFeeders:
        return <RssSearchDashboard />

      case _sdm.district.dataIssues:
        return <SportsDataIssues fromDashboard={true} />

      case _sdm.district.sportsDashboard:
        return <ValidateSports fromDashboard={true} />

      case _sdm.district.glsScores:
      case _sdm.district.glsAccess:
      case _sdm.district.glsDistrict:
        return <UiDashboardForm sportsDataMode={sportsDataMode} forSportsManagement={true} />

      case _sdm.sports.playoffPendingMatches:
        return <MatchPlayoffUpdate />

      case _sdm.sports.seasonResults:
        return <MatchDataUpdate forSportsManagement={true} sportsDataMode={sportsDataMode} />

      case _sdm.sports.sectionGrids:
        return <SeasonGrids forSportsManagement={true} sportsDataMode={sportsDataMode} />

      case _sdm.sports.seasonRankings:
        return <SeasonRankingsUpdate forSportsManagement={true} sportsDataMode={sportsDataMode} />

      case _sdm.sports.sponsors:
        return <CreateSponsors />

      // case _sdm.sports.backupSeason:
      case _sdm.sports.createPlayoff:
      case _sdm.sports.createSeason:
      case _sdm.sports.createSportsTeams:
      case _sdm.sports.createTournament:
      case _sdm.sports.createTournamentPlayoff:
      case _sdm.sports.editCurrentSeason:
      case _sdm.sports.editTryoutRoster:
      case _sdm.sports.editSeason:
      case _sdm.sports.sportsSettings:
      case _sdm.sports.modifySeasonMatches:
      case _sdm.sports.modifySchedules:
        return <CreateSports
          fromDashboard={true}
          subActionType={sportsDataMode}
          latestSeason={latestSeason}
          handleCancel={handleClose}
        />

      case _sdm.district.transferData:
        return <AppDataTransferDirectWithProvider clickOriginType={clickOriginTypes.dataViewer} appFormTransferType={appFormTypes.transferDataDirect} />

      // case _sdm.district.districtSchools:
      case _sdm.organization.schools:
        return <SportSchools sportsDataMode={sportsDataMode} />

      case _sdm.organization.districts:
        return <OrganizationDistricts sportsDataMode={sportsDataMode} />

      case _sdm.district.districtSchools:
        return <DistrictSchools fromDashboard={true} />

      case _sdm.district.districtSports:
        return <DistrictSports fromDashboard={true} />

      case _sdm.sports.appUserCount:
      case _sdm.district.appUserCount:
        return <WeeksTimeline data={currentUserCounts} />

      case _sdm.sports.appUserDailyCount:
      case _sdm.district.appUserDailyCount:
        return <CalendarTimeline data={dailyCounts?.fullCount} />

      default:
        return <div>{'sportsDataMode ' + sportsDataMode + ' is not recognized'}</div>
    }
  }, [sportsDataMode, latestSeason, sportsKey])

  const header = useMemo(() => <div className={'header-flex'}>
    {modeButton()}
    <ParentKeysDd parentDataKeys={parentDataKeys} pathViews={pathViews} />
  </div>, [sportsDataMode, parentDataKeys, pathViews])

  const wrapper = () => <Wrapper
    header={header}
    content={content}
    wrapperType={wrapperTypes.paddedHeaderAndFooter}
    css={{ container: 'wrp' }}
  />

  const sidebar = () => <Sidebar.Pushable style={{ overflow: 'hidden' }}>
    {sidebar_left(mode ? true : false)}
    <Sidebar.Pusher dimmed={mode ? true : false} className={'h100'}>
      {wrapper()}
    </Sidebar.Pusher>
  </Sidebar.Pushable>

  const fullPageWrapper = () => <FullPageWrapper
    content={sidebar()}
    handleCancel={handleCancel}
    topperCaption={captions.topper}
    topperCaption2={captions.topper2}
    fullMode={true}
    css={{ container: 'sports-dashboard app-dark-mode' }}
  />

  return fullPageWrapper()

}

export default SportsDashboard